import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import Box from '../Box';
import axios from 'axios';

const AdminCompany = (props) => {

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
    }, []);

    const handleInputChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }

    const adminCompany = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        if (props.method === 'NEW'){
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/company`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            });
        }

        if (props.method === 'EDIT'){
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/company`,
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            options.data.idCompany = props.currentSelected.id;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            });
        }


        if (props.method === 'DELETE'){
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/company`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            options.data.idCompany = props.currentSelected.id;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            }).catch(function (error) {
                if (error.response.status === 500 && error.response.data != null) {
                    setError('No es posible eliminar la empresa seleccionada ya que hay datos vinculados a esta.');
                }
            });
        }
    }

    return (
        <Fragment>
            {props.method ==='NEW' ? (
                <Fragment>
                    <h3>Nueva empresa</h3>
                    <p>Ingrese el nombre de la nueva empresa y haga click<br />en "Añadir".</p>
                </Fragment>
            ) : props.method === 'EDIT' ? (
                <Fragment>
                    <h3>Modificar empresa</h3>
                    <p>Modifique el nombre de la empresa y haga click<br />en "Modificar".</p>
                </Fragment>
            ) : props.method === 'DELETE' ? (
                <Fragment>
                    <h3>Eliminar empresa</h3>
                    <p className="center">¿Está seguro de eliminar la empresa <b>{props.currentSelected.desc}</b>?</p>
                </Fragment>
            ) : null}
            
            <div className="flexRow">
                {props.method === 'NEW' ? (
                    <div className="flexCol">
                        <Box type="text" name="companyName" label="Nombre nueva empresa" className="x3" placeholder="Ingrese nombre ..." onChange={handleInputChange}></Box>
                        <button className="collapsed" type="button" onClick={() => adminCompany()}>Añadir</button>
                    </div>
                ) : props.method === 'EDIT' ? (
                    <div className="flexCol">
                        <Box type="text" name="companyName" label="Nombre nueva empresa" value={props.currentSelected.desc} className="x3" placeholder="Ingrese nombre ..." onChange={handleInputChange} ></Box>
                        <button className="collapsed" type="button" onClick={() => adminCompany()}>Modificar</button>
                    </div>
                ) : props.method === 'DELETE' ? (
                    <div className="flexCol fullWidth center">
                        <button className='aloneInRow normalHeight' type="button" onClick={() => adminCompany()}>Si, eliminar</button>
                    </div>
                ) : null}
            </div>
            {error ? (<div className="errorWrapper">{error}</div>):null}
        </Fragment>
    );
    
}

export default AdminCompany;